import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getServiceName } from '../services/selectors';

const mapStateToProps = (state, ownProps) => ({
  serviceName: getServiceName(state, ownProps.params.serviceId),
});

export default compose(
  withRouter,
  connect(mapStateToProps),
);



// WEBPACK FOOTER //
// ./src/app/hoc/WithServiceName.js